import { doc, getDoc, updateDoc } from 'firebase/firestore';
import type { DocumentData } from 'firebase/firestore';
import { db } from './config';

/**
 * Acesso ao doc raiz `clinics/{clinicId}` (nome, endereço, contato, logo,
 * configs). Vários pontos da UI liam/escreviam esse doc direto do
 * Firestore — concentrar aqui é o passo 1 da regra "Firestore só via
 * services/". Listeners realtime (useRBAC/AuthContext) e a criação da
 * clínica (RegisterClinicPage) continuam nos seus donos.
 */
export const ClinicService = {
  /** Dados crus do doc (sem normalização), ou null quando não existe. */
  async getClinicDoc(clinicId: string): Promise<DocumentData | null> {
    const snap = await getDoc(doc(db, 'clinics', clinicId));
    return snap.exists() ? snap.data() : null;
  },

  /** Atualização parcial do doc raiz (identidade, logo, configs). */
  async updateClinicDoc(clinicId: string, data: Record<string, unknown>): Promise<void> {
    await updateDoc(doc(db, 'clinics', clinicId), data);
  },
};
